// 1️⃣ Imports must be at the top
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PageHeader from "./Header";
import Footer from "./Footer";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import $ from "jquery"; // import jQuery
import Swal from 'sweetalert2';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

window.$ = $;
window.jQuery = $;


const PageLayout = ({ children }) => {
  return (
    <div>
      <PageHeader />
      {children}
      
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default PageLayout;
